(() => {
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];

  const setBodyLock = () => {
    document.body.classList.toggle('drawer-open', !!qs('.mobile-drawer.is-open, .search-modal.is-open, .facets.is-open'));
  };

  const closeOverlays = () => {
    qsa('.mobile-drawer.is-open, .search-modal.is-open, .drawer-overlay.is-open, .facets.is-open').forEach(el => el.classList.remove('is-open'));
    qsa('[aria-expanded="true"]').forEach(el => el.setAttribute('aria-expanded', 'false'));
    setBodyLock();
  };

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-toggle]');
    if (trigger) {
      const target = qs(trigger.dataset.toggle);
      if (!target) return;
      event.preventDefault();
      const opening = !target.classList.contains('is-open');
      closeOverlays();
      target.classList.toggle('is-open', opening);
      trigger.setAttribute('aria-expanded', String(opening));
      const overlay = qs('.drawer-overlay');
      if (overlay && target.matches('.mobile-drawer, .facets')) overlay.classList.toggle('is-open', opening);
      setBodyLock();
      if (opening) setTimeout(() => qs('input[type="search"]', target)?.focus(), 100);
    }
    if (event.target.closest('[data-close-overlay]') || event.target.classList.contains('drawer-overlay')) closeOverlays();
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    closeOverlays();
    qsa('[data-chat-widget].is-open').forEach(widget => {
      widget.classList.remove('is-open');
      qs('[data-chat-toggle]', widget)?.setAttribute('aria-expanded', 'false');
      qs('[data-chat-panel]', widget)?.setAttribute('aria-hidden', 'true');
    });
  });

  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-chat-toggle]');
    if (toggle) {
      const widget = toggle.closest('[data-chat-widget]');
      const opening = !widget.classList.contains('is-open');
      qsa('[data-chat-widget].is-open').forEach(item => {
        item.classList.remove('is-open');
        qs('[data-chat-toggle]', item)?.setAttribute('aria-expanded', 'false');
        qs('[data-chat-panel]', item)?.setAttribute('aria-hidden', 'true');
      });
      widget.classList.toggle('is-open', opening);
      toggle.setAttribute('aria-expanded', String(opening));
      qs('[data-chat-panel]', widget)?.setAttribute('aria-hidden', String(!opening));
      return;
    }
    if (!event.target.closest('[data-chat-widget]')) {
      qsa('[data-chat-widget].is-open').forEach(widget => {
        widget.classList.remove('is-open');
        qs('[data-chat-toggle]', widget)?.setAttribute('aria-expanded', 'false');
        qs('[data-chat-panel]', widget)?.setAttribute('aria-hidden', 'true');
      });
    }
  });

  class HeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = qsa('.hero-slide', this);
      this.dots = qsa('.hero-slider__dot', this);
      this.index = 0;
      this.delay = Number(this.dataset.autoplay) * 1000;
      qs('[data-hero-prev]', this)?.addEventListener('click', () => this.show(this.index - 1, true));
      qs('[data-hero-next]', this)?.addEventListener('click', () => this.show(this.index + 1, true));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('touchstart', event => this.touchX = event.touches[0].clientX, {passive:true});
      this.addEventListener('touchend', event => {
        const diff = (this.touchX || 0) - event.changedTouches[0].clientX;
        if (Math.abs(diff) > 45) this.show(this.index + (diff > 0 ? 1 : -1), true);
      }, {passive:true});
      this.start();
    }
    show(index, restart = false) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
        slide.setAttribute('aria-hidden', String(i !== this.index));
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
      if (restart) { this.stop(); this.start(); }
    }
    start() { if (this.delay > 0 && this.slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) this.timer = setInterval(() => this.show(this.index + 1), this.delay); }
    stop() { clearInterval(this.timer); }
    disconnectedCallback() { this.stop(); }
  }
  customElements.define('hero-slider', HeroSlider);

  class ReviewSlider extends HTMLElement {
    connectedCallback() {
      this.track = qs('.review-track', this);
      this.cards = qsa('.review-card', this);
      this.index = 0;
      qs('[data-review-prev]', this)?.addEventListener('click', () => this.move(-1));
      qs('[data-review-next]', this)?.addEventListener('click', () => this.move(1));
      this.resize = () => this.update();
      window.addEventListener('resize', this.resize);
    }
    visible() { return innerWidth < 750 ? 1 : innerWidth < 1101 ? 2 : 3; }
    move(step) { this.index = Math.max(0, Math.min(this.index + step, this.cards.length - this.visible())); this.update(); }
    update() {
      if (!this.cards.length) return;
      this.index = Math.min(this.index, Math.max(0, this.cards.length - this.visible()));
      const cardWidth = this.cards[0].getBoundingClientRect().width + 18;
      this.track.style.transform = `translate3d(${-this.index * cardWidth}px,0,0)`;
    }
    disconnectedCallback() { window.removeEventListener('resize', this.resize); }
  }
  customElements.define('review-slider', ReviewSlider);

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;
      fetch(url).then(response => response.text()).then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations?.innerHTML.trim()) {
          this.innerHTML = recommendations.innerHTML;
          qsa('.reveal', this).forEach(card => card.classList.add('is-visible'));
        }
      }).catch(() => {});
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  qsa('[data-collection-tabs]').forEach(group => {
    qsa('[data-collection-tab]', group).forEach(tab => tab.addEventListener('click', () => {
      qsa('[data-collection-tab]', group).forEach(item => item.classList.remove('is-active'));
      qsa('[data-collection-panel]', group).forEach(item => item.classList.remove('is-active'));
      tab.classList.add('is-active');
      qs(`#${CSS.escape(tab.dataset.collectionTab)}`, group)?.classList.add('is-active');
    }));
  });

  const updateCartCount = count => qsa('[data-cart-count]').forEach(el => { el.textContent = count; el.hidden = count < 1; });
  const showToast = text => {
    const toast = qs('[data-cart-toast]');
    if (!toast) return;
    const label = qs('[data-cart-toast-text]', toast);
    if (label && text) label.textContent = text;
    toast.classList.add('is-visible');
    toast.setAttribute('aria-hidden', 'false');
    clearTimeout(window.hwdToastTimer);
    window.hwdToastTimer = setTimeout(() => { toast.classList.remove('is-visible'); toast.setAttribute('aria-hidden','true'); }, 3600);
  };

  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-ajax-cart-form], form.product-form');
    if (!form || !window.fetch) return;
    if (form.matches('form.product-form') && event.submitter && !event.submitter.matches('[data-add-to-cart]')) return;
    event.preventDefault();
    const button = event.submitter?.matches('[data-add-to-cart]') ? event.submitter : qs('[data-add-to-cart], [type="submit"]', form);
    const oldText = button?.innerHTML;
    if (button) { button.disabled = true; button.textContent = 'Wird hinzugefügt …'; }
    try {
      const response = await fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', {method:'POST', headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'}, body:new FormData(form)});
      if (!response.ok) throw new Error((await response.json()).description || 'Produkt konnte nicht hinzugefügt werden.');
      const cart = await fetch('/cart.js').then(r => r.json());
      updateCartCount(cart.item_count);
      showToast('Zum Warenkorb hinzugefügt');
    } catch (error) { showToast(error.message); }
    finally { if (button) { button.disabled = false; button.innerHTML = oldText; } }
  });

  document.addEventListener('click', event => {
    const quantityButton = event.target.closest('[data-quantity-change]');
    if (!quantityButton) return;
    const input = qs('input[type="number"]', quantityButton.closest('.quantity'));
    if (!input) return;
    const next = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(quantityButton.dataset.quantityChange));
    input.value = next;
    input.dispatchEvent(new Event('change', {bubbles:true}));
  });

  qsa('form.product-form').forEach(form => {
    const variantDataEl = qs('[data-variant-json]', form);
    if (!variantDataEl) return;
    const variants = JSON.parse(variantDataEl.textContent);
    const idInput = qs('[name="id"]', form);
    const button = qs('[type="submit"]', form);
    const price = qs('[data-product-price]');
    const options = qsa('[data-option-input]', form);
    const selectVariant = () => {
      const selected = [];
      qsa('[data-option-group]', form).forEach(group => selected.push(qs('[data-option-input]:checked', group)?.value));
      const variant = variants.find(item => item.options.every((option, index) => option === selected[index]));
      if (!variant) { if (button) { button.disabled = true; button.textContent = 'Nicht verfügbar'; } return; }
      idInput.value = variant.id;
      if (button) { button.disabled = !variant.available; button.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft'; }
      if (price) price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(variant.price / 100);
      if (variant.featured_image) qs(`[data-image-id="${variant.featured_image.id}"]`)?.click();
      if (history.replaceState) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    };
    options.forEach(option => option.addEventListener('change', selectVariant));
  });

  qsa('[data-product-gallery]').forEach(gallery => qsa('[data-image-id]', gallery).forEach(thumb => thumb.addEventListener('click', () => {
    const main = qs('#ProductMainImage', gallery);
    if (!main) return;
    main.src = thumb.dataset.imageSrc;
    main.srcset = '';
    qsa('[data-image-id]', gallery).forEach(item => item.classList.remove('is-active'));
    thumb.classList.add('is-active');
  })));

  const revealObserver = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); } }), {threshold:.08});
  qsa('.reveal').forEach(el => revealObserver.observe(el));

  document.addEventListener('shopify:section:load', event => qsa('.reveal', event.target).forEach(el => revealObserver.observe(el)));
})();
